import React from 'react';
import jwtDecode from 'jwt-decode';
import { Modal, CheckBox, Spinner } from 'hyperdb-utils';
import api from 'api';
import EmailForm from '../../email/message/containers/Form';
import { FILESTORE_URL } from '../../../../config';

class ModalEmailAction extends React.Component {
  constructor(props) {
    super(props);
    this.handleClickCheckbox = this.handleClickCheckbox.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount() {
    const customer = this.props.reservation.customer;
    const message = {
      ...this.props.objectData,
      type: this.props.templateCode,
      recipient: customer ? `${customer.name} <${customer.entity.primary_email}>` : (this.props.recipient || ''),
      language: (customer || {}).language || 'en',
      template_id: { $type: 'reference', value: ['email_templates', this.props.templateId] },
      account: { $type: 'reference', external: true, value: ['email_accounts'] },
      attachments: ['confirm', 'resend_confirmation'].includes(this.props.selectedAction) ? this.props.reservation.attachments : null,
      quote_replied_message: this.props.quoteRepliedMessage,
    };
    if (!customer) this.props.api.message.setData({ recipientEmail: this.props.recipient || '' })
    if (this.props.repliedMessageId) {
      message.replied_message_id = { $type: 'reference', value: ['messages', this.props.repliedMessageId] };
    }
    this.props.api.message.setData({ objectData: message, sendEmail: this.props.defaultSendEmail || false });
  }
  componentWillUnmount() {
    this.props.api.message.setData({ sendEmail: false, blockDates: false, objectData: null });
  }
  render() {
    return (
      <Modal title={ this.props.title } onClose={ this.props.onClose } onAccept={ this.handleSubmit } loading={ this.props.processingAction }>
        <Spinner show={ this.props.loading } />
        {
          !this.props.forceSendEmail && !this.props.noEmail
            ? <CheckBox
                label={ this.props.labelSendEmail || 'Send information email to client' }
                checked={ this.props.sendEmail }
                onChange={ this.handleClickCheckbox.bind(this, 'sendEmail') } />
            : null
        }
        {
          this.props.selectedAction === 'confirm_availability' || this.props.selectedAction === 'make_offer'
            ? <CheckBox
                label="Block dates"
                checked={ this.props.blockDates }
                onChange={ this.handleClickCheckbox.bind(this, 'blockDates') } />
            : null
        }
        {
          !this.props.noEmail
            ? <div>
              {
                !this.props.objectData
                  ? <Spinner show={ true } />
                  : <EmailForm
                      showSaveButtons={ false }
                      showAttachments={ true }
                      attachmentsBaseUrl={ this.attachmentsBaseUrl() }
                      disallowAttachments={ true }
                      hide={ !this.props.sendEmail && !this.props.forceSendEmail || this.props.noEmail }
                      objectData={ this.props.objectData }
                      relatedObject={ this.props.reservation }
                      searchAvailabilities={ this.props.searchAvailabilities }
                      canCreateCustomer={ this.props.canCreateCustomer }
                    />
              }
              </div>
            : null
        }
        {
          !this.props.reservation.strictly_available && ['confirm_availability'].includes(this.props.selectedAction)
            ? <p className="text-danger"><i className="fas fa-warning"/> <strong>This inquiry doesn't respect the conditions. Are you sure ?</strong></p>
            : null
        }
        <br/>
        { this.props.confirmMessage }
      </Modal>
    );
  }

  attachmentsBaseUrl() {
    const { currentUser } = this.props.api.getState('auth');
    const decoded = jwtDecode(currentUser.jwt);
    return `${FILESTORE_URL}/${decoded.client_id}/`;
  }

  handleClickCheckbox(attrName) {
    const checked = !this.props[attrName];
    this.props.api.message.setData({ [attrName]: checked });
  }
  handleSubmit() {
    const message = !this.props.sendEmail && !this.props.forceSendEmail
      ? null
      : this.props.objectData;
    this.props.onSubmit({
      id: this.props.reservation.id,
      message,
      blockDates: this.props.blockDates,
    });
  }
}

ModalEmailAction.propTypes = {
  api: React.PropTypes.object,
  router: React.PropTypes.object,
  objectData: React.PropTypes.object,
  reservation: React.PropTypes.object,
  selectedAction: React.PropTypes.string,
  templateCode: React.PropTypes.string,
  templateId: React.PropTypes.string,
  updateEditedObject: React.PropTypes.func,
  availableLanguages: React.PropTypes.array,
  forceSendEmail: React.PropTypes.bool,
  sendEmail: React.PropTypes.bool,
  noEmail: React.PropTypes.bool,
  title: React.PropTypes.string,
  onClose: React.PropTypes.func,
  onSubmit: React.PropTypes.func,
  labelSendEmail: React.PropTypes.string,
  confirmMessage: React.PropTypes.string,
};

export default api.connect(ModalEmailAction, 'message', { noClearOnUnmount: true });



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/common/ModalEmailAction.jsx